module.exports = __webpack_public_path__ + "static/media/plane.95d845c0.png";